import { supabase } from '../lib/supabaseClient';
import { buildE2eStubSession, isE2eStubAuthEnabled } from './e2eStubAuth';

export async function getAccessToken(): Promise<string | null> {
  if (isE2eStubAuthEnabled()) {
    return buildE2eStubSession().access_token;
  }
  if (!supabase) {
    return null;
  }
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    return null;
  }
  return data.session?.access_token ?? null;
}
